import React from 'react';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import { useTranslation } from 'react-i18next';

import scss from './EmptyHistory.module.scss';

function EmptyHistory() {
  const { t } = useTranslation('studio');

  return (
    <div className={scss.emptyHistory}>
      <HistoryOutlinedIcon className={scss.icon} />
      <span className={scss.label}>{t('emptyRequestsHistory')}</span>
    </div>
  );
}

export default EmptyHistory;
